import functionUncurryThisAccessor from './function-uncurry-this-accessor.mjs';
import classofRaw from './classof-raw.mjs';

var uncurryThisAccessor = functionUncurryThisAccessor;
var classof = classofRaw;

var $TypeError = TypeError;

// Includes
// - Perform ? RequireInternalSlot(O, [[ArrayBufferData]]).
// - If IsSharedArrayBuffer(O) is true, throw a TypeError exception.
var arrayBufferByteLength = uncurryThisAccessor(ArrayBuffer.prototype, 'byteLength', 'get') || function (O) {
  if (classof(O) !== 'ArrayBuffer') throw new $TypeError('ArrayBuffer expected');
  return O.byteLength;
};

export { arrayBufferByteLength as default };
